import { useEffect, useMemo, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
// import { DevTool } from "@hookform/devtools";
import useAxios from "../../../hooks/useAxios";
import axiosInstance from "../../../apis/commonAPI";
// import {SESSION_DATA, user,} from "../../constants";
// import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CiSquarePlus } from "react-icons/ci";
import { FaMinus, FaPlus } from "react-icons/fa";


const AddEditDomain = () => {
  const navigate = useNavigate();
const [subDomainArray, setSubDomainArray] = useState([{'subDomainName':''}]);
const { id } = useParams();
  const [addUpdate, setAddUpdate] = useState(false);





  const [submitForm, errorSubmit, loadingSubmit, axiosSubmit] =
    useAxios();
      const [subDomainData, errorSubDomain, loadingSubDomain, axiosSubDomain] =
        useAxios();


  const SUBMIT_FORM_DATA_URL = id && id != undefined?`master/updateDomainData/${id}`:'master/createDomainData';;
  const GET_Domain_URL = id && id != undefined?`master/getDomainData/${id}`:"";


  const getDomain = (url) => {
    axiosSubDomain({
        axiosInstance: axiosInstance,
        url: url,
        method: "GET",
      });
    };

     useEffect(() => {
          const fetchDomain = async () => {
            if (!id) return;
        
            try {
              getDomain(GET_Domain_URL);
            
            } catch (error) {
              console.error("Error fetching  data:", error);
            }
          };
        
          fetchDomain();
        }, [GET_Domain_URL]);

    console.log(" get domain data",subDomainData)

        useEffect(() => {
          const fetchDomainData = async () => {
            if (!id) return;
        
            try {
              if (subDomainData?.length > 0) {
                setSubDomainArray(subDomainData[0].subDomains);
                setValue("domainName", subDomainData[0].domainName);
              } else {
                console.warn("No  data found for the given ID");
              }
            } catch (error) {
              console.error("Error fetching  data:", error);
            }
          };
        
          fetchDomainData();
        }, [loadingSubDomain]);

  const form = useForm({
    defaultValues: {
      
    },
  });
  const {
    register,
    control,
    handleSubmit,
    formState,
    watch,
    setValue,
    getValues,
    resetField,
    reset,
  } = form;
  const { errors } = formState;

  const toTitleCase = (str) => {
    return str.toLowerCase().replace(/(^|\s|-|\')(\w)/g, (match) => {
      return match.toUpperCase();
    });
  };

  const onFormSubmit = async (data) => {
    // let getSubDomainArray = [];
   
    // for (let numRow = 0; numRow < subDomainNo.length; numRow++) {
    //   if(data[`subDomainName_${numRow}`] !=="" && data[`subDomainName_${numRow}`] !== null && data[`subDomainName_${numRow}`] !== undefined){
    //     getSubDomainArray.push({
        
    //       subDomainName: toTitleCase(data[`subDomainName_${numRow}`]),
          
    //     });
    //   }
     
    // }
   

    
    if(subDomainArray.length>0){
      let formData = {
        domainName: toTitleCase(data.domainName),
        subDomains: subDomainArray,
        status: "A"
       
      };
  console.log("formData test",formData);
      await axiosSubmit({
        axiosInstance: axiosInstance,
        url: SUBMIT_FORM_DATA_URL,
        method: "POST",
        requestConfig: {
          data: formData,
        },
      });
  
      setAddUpdate(true);
    }else{
      toast.error(
        `Atleast One Subdomain is Required`,
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    }
    
  };
  useEffect(() => {
    if (errorSubmit) {
      toast.error(
        `Your information could not be Added!!error:${errorSubmit}`,
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    } else if (addUpdate) {
      navigate(
        `/master/domainlisting`
      );
    }
  }, [loadingSubmit, errorSubmit]);

  const handleSubdomain = (isMinus, index = 0) => {
    if (isMinus) {
      const copySubDomain = [...subDomainArray];
      copySubDomain.splice(index, 1);
      setSubDomainArray(copySubDomain);
      resetField(`subDomainName_${index}`)

     
    };
     if (isMinus === false) {
      const subDomainArrayCopy = [...subDomainArray];
      subDomainArrayCopy.push({ subDomainName: "" });
      setSubDomainArray(subDomainArrayCopy);

    }
  }

  const handleSubdomainValue = (e, index) => {
    const subValue = e.target.value;
    const updatedArray = [...subDomainArray];
  
    // Replace object with a new one
    updatedArray[index] = { ...updatedArray[index], subDomainName: toTitleCase(subValue) };
  
    setSubDomainArray(updatedArray);
  };

  return (
    <>
      <div className="card min-height-100">
        <div className="card-title flex-row">
          <h2>{id ? "Edit" : "Add"} Domain </h2>
          <Link to="/master/domainListing">
            <button className="btn btn-blue rounded-10">Back</button>
          </Link>
        </div>
        <ToastContainer />

        <FormProvider {...form}>
          <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
            <div className="row mt-30">
            <div className="col-md-4  tank-col-info">
                <label htmlFor="domainName" className="text-gray text-semi-bold">
                  Domain Name<span className="text-red">*</span>
                </label>
                <input
                  id="domainName"
                  {...register("domainName", {
                    required: {
                      value: true,
                      message: "Domain Name Field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter Domain name"
                />
                <p className="text-red">{errors.domainName?.message}</p>
              </div>
              {
                subDomainArray?.map((fetchRows,index) => (
                  <div className="col-md-4  tank-col-info">
                    <div className= "row">

<div className="col-md-10">

<label htmlFor={`subDomainName_${index}`} className="text-gray text-semi-bold">
                    Sub Domain Name<span className="text-red">*</span>
                  </label>
                  <input
                    id={`subDomainName_${index}`}
                    {...register(`subDomainName_${index}`, {
                      required: {
                        // value: true,
                        message: "Sub Domain Name Field is Required",
                      },
                    })}
                    type="text"
                    className="form-control rounded-10 mb-15"
                    placeholder="Enter Sub Domain name"
                    onChange={(e) => handleSubdomainValue(e, index)}
                    value={fetchRows.subDomainName}
                  />
                  <p className="text-red">{errors?.[`subDomainName_${index}`]?.message}</p>
                
</div>
<span className="col-md-2 text-left mt-20">
  <button
  type="button"
                    className="btn btn-sm btn-outline-gray rounded-10"
                    title= "click to add district"
                    onClick={() => {handleSubdomain(true,index)
                    }}
                  
                  ><FaMinus /></button>
</span>
</div>

</div>
                 

                ))
              }
          
              <div className="col-md-4 text-left mt-20">
                <button
                  className="btn btn-sm btn-secondary rounded-10"
                  title= "click to add sub domain"
                  type="button"
                  onClick={() => {handleSubdomain(false)
                  }}
                ><FaPlus /></button>
              </div>
            
            

              <div className="col-md-12 text-center">
                <input
                  type="submit"
                  className="btn btn-red rounded-10"
                  value="Submit"
                />
              </div>
            </div>
          </form>
        </FormProvider>

       
      </div>
    </>
  );
};

export default AddEditDomain;
